exports = module.exports = require("../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".overlay-video{height:100%;width:100%;position:absolute;top:0px;left:0px;z-index:2;background:rgba(19,7,0,.4)}video{min-width:100%;min-height:100%;position:relative;z-index:1}body.modal-open{overflow:hidden !important;position:fixed}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../lunch-team-client-checkout-msg/node_modules/css-loader!../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./src/containers/Landing/LunchTeamMainPresentation/lunchTeamMainPresentation.scss
// module id = 926
// module chunks = 7